import React from 'react'
import { HomeCover, HomeSectionI,  HomeSectionII, HomeSectionIII, HomeSectionFour, HomeSectionFive  } from '../components'

const Home = () => {
  return (
    <section>
      <HomeCover/>
      <HomeSectionI/>
      <HomeSectionII/>
      <HomeSectionIII/>
      <HomeSectionFour/>
      <HomeSectionFive/>
    </section>
  )
}

export default Home